import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    stake: 'Unstake',
    inputTokenLabel: 'Amount {token}',
    inputLabelTooltip:
      '{token} is a reward-bearing token with rewards built in. Redemption ratio grows daily, but quantity never changes. ',
    exchangeRateLabel: 'Exchange rate',
    rateValues: '{input} = {output}',
  },
};
